import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";

import Draggable from "react-draggable";
import Select from "react-select";
import swal from "sweetalert";
import { LoadingSpinner } from "../../../../constants/const";
import { GetLanguageString } from "../../../helper/Components";
import { GetSelectedLanguage } from "../../../helper/Method";
import { ApiFinance } from "../ApiFinance";

const UpdateFinanceDimensions = ({
  setUpdateModal,
  financeAccountCategoryId,
  previouslySelectedFinanceDimensions,
  reload,
  setReload,
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [financeDimensions, setFinanceDimensions] = useState([]);
  const [selectedFinanceDimensions, setSelectedFinanceDimensions] = useState(
    previouslySelectedFinanceDimensions || []
  );
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const toggle = () => setUpdateModal(false);

  const handleDrag = (e, ui) => {
    setPosition((prev) => ({ x: prev.x + ui.deltaX, y: prev.y + ui.deltaY }));
  };


  // Fetch and map finance dimensions
  useEffect(() => {
    setLoading(true);
    ApiFinance()
      .GetFinanceDimensionsListFromFinanceSoftware()
      .then((res) => setFinanceDimensions(res.data || []))
      .catch((err) =>
        swal({
          title: "Error",
          text: err.response?.data || err.message,
          icon: "error",
          buttons: "OK",
        })
      )
      .finally(() => setLoading(false));
  }, []);

  const handleSelectFinanceDimensions = (selectedOptions) => {
    setSelectedFinanceDimensions(selectedOptions || []);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);
    ApiFinance()
      .UpdateFinanceDimensions2(
        financeAccountCategoryId,
        selectedFinanceDimensions
      )
      .then(() => {
        swal({
          title: t("finance_finance_dimensions_updated"),
          className: GetSelectedLanguage() === "en" ? "" : "ur",
          icon: "success",
          buttons: "OK",
        });
        setReload(!reload);
        toggle();
      })
      .catch((err) => {
        swal({
          title: err.message || "Something went wrong",
          text: err.response?.data || "",
          icon: "error",
          buttons: "OK",
        });
        toggle();
      })
      .finally(() => setLoading(false));
  };

  return (
    <Draggable position={position} onDrag={handleDrag} cancel=".no-drag">
      <Modal isOpen className="inmodal" autoFocus={false}>
        <ModalHeader tag="h4">
          <GetLanguageString props="finance_tab_finance_dimensions_update" />
        </ModalHeader>

        {!loading ? (
          <Form onSubmit={handleSubmit}>
            <ModalBody>
              <FormGroup>
                <Label className="col-form-label">
                  <GetLanguageString props="finance_finance_dimensions" />
                </Label>

                <Select
                  isMulti
                  options={financeDimensions}
                  value={selectedFinanceDimensions}
                  onChange={handleSelectFinanceDimensions}
                  getOptionValue={(opt) => opt.value}
                  getOptionLabel={(opt) => opt.label}
                  // components={{ MenuList: VirtualizedMenuList }}
                  className="basic-multi-select no-drag"
                  classNamePrefix="select"
                />

              </FormGroup>
            </ModalBody>

            <ModalFooter>
              <Button color="white" onClick={toggle}>
                <GetLanguageString props="common_cancel" />
              </Button>
              <Button color="primary" type="submit">
                <GetLanguageString props="update" />
              </Button>
            </ModalFooter>
          </Form>
        ) : (
          LoadingSpinner()
        )}
      </Modal>
    </Draggable>
  );
};

export default UpdateFinanceDimensions;
